// Cakeのview(.ctp)からも呼ばれるのでグローバルで定義
global.$          = require('jquery');
global.jQuery     = $;
global._          = require('underscore');
global.Backbone   = require('backbone');
Backbone.$        = $;
global.Handlebars = require('../handlebars-require');

// jQuery plugins
require('jquery-ui');
require('blueimp-file-upload/jquery.iframe-transport');
require('blueimp-file-upload/jquery.fileupload');
require('fancybox')($);

// Google Analytics
require('tracking')

// Appの定義
global.App = require('namespace');
require('util')();
require('pcView')();
App.Inits  = require('pcInit');

//$.ajax関数の設定
$.ajaxSetup({
  dataType: 'json',
  timeout: 40000
});

$(function(){
    // initメソッドを呼び出す
    if (!_.isEmpty(App.init_fn) && _.has(App.Inits, App.init_fn.controller) && _.has(App.Inits[App.init_fn.controller], App.init_fn.action)) {
        // App.varsを深いコピーして,参照渡しする。
        App.Inits[App.init_fn.controller][App.init_fn.action].call(App.Inits[App.init_fn.controller], App.vars);
    }
    // varsはスコープが広すぎるので、初期化関数に渡したら消す
    //App.vars = null;

    $(document).click(function() { $('.nav-list > li > ul').hide(); });
    $('.nav-list > li').click(function(ev){
      var sub = $(this).children('ul');
      if ($(sub).is(':hidden')) {
        ev.stopPropagation();
        $('.nav-list > li > ul:visible').hide();
        $(sub).show();
      }
    });

});

var KininaruView = require('../view/kininaru');
new KininaruView();



// WEBPACK FOOTER //
// ./pc/app.js